import React, {  } from 'react'
import { Tooltip } from 'antd';

const DietaryIcon = ({dietary}) => {
  const dietaryImageUrl = dietary && dietary.image ? dietary.image.url : "";
  return (
    <Tooltip title={dietary.description} trigger={"hover"}>
      <figure className='dietary__image' key={dietary.id}>
        {dietaryImageUrl && (
          <img src={dietaryImageUrl} alt={dietary.name} className="img-fluid rounded-circle" />
        )}
      </figure>
    </Tooltip>
);
};

export default DietaryIcon;
